import { BasicResult } from '../basic-result';

export class UpsertEventTemplateResult extends BasicResult {
  EventWorkflowID = -1;
}
